const NewsletterSubscriptionStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUBSCRIBED: 'SUBSCRIBED',
  ERROR: 'ERROR',
};

export default NewsletterSubscriptionStatus;
